import { FC } from 'react'
import Image from 'next/image'
import { RewardType } from '@g4g/graphql/src/shop/__generated__/globalTypes'
import salePointsImg from '@/shop/public/shared-assets/img/legendary_gemstone.png'
import discountImg from '@/shop/public/shared-assets/img/discount_icon.png'
import VipExpLevelIcon from '../../VipExpLevelIcon'

const RewardProgressBarIcon: FC<{
  side: 'start' | 'end'
  type: RewardType.SalePoints | RewardType.VipExp
  size: number
  amount?: number
}> = ({ side, size, type, amount }) => {
  return (
    <div>
      {type === RewardType.SalePoints ? (
        <Image
          src={side === 'start' ? salePointsImg : discountImg}
          width={size}
          height={size}
          alt={`Sale points progress bar ${side}`}
        />
      ) : (
        <>{amount !== undefined && <VipExpLevelIcon vipExp={amount} size={size} />}</>
      )}
    </div>
  )
}

export default RewardProgressBarIcon
